import { JsonSerializable } from "@/Common/Models/JsonSerializable";
import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";
import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { WeightUnitConverter } from "@/Common/Utilities/Units/WeightUnitConverter";
import { GestationalAge } from "./GestationalAge";

class ObstetricalHistoryItem extends JsonSerializable {
    private _id: number;

    public Date: Date | null;
    public DatePrecision: LifeStageDatePrecisionEnum;
    public PlaceOfBirth: string;
    public GestationWeeksAtBirth?: GestationalAge;
    public LabourHours: string;
    public TypeOfBirth: string;
    public Comments: string;
    public Sex: string;
    /**
     * @deprecated Use BirthWeightValue instead
     */
    public BirthWeight: string;
    public BirthWeightValue: number;
    public BreastfedMonths: string;
    public ChildCurrentHealth: string;

    constructor(fields?: Partial<ObstetricalHistoryItem>) {
        super({ excludedFields: ["_id"] });

        Object.assign(this, fields);
        this._id = sessionStore.newId();
        this.GestationWeeksAtBirth = new GestationalAge(fields?.GestationWeeksAtBirth);
    }

    public getId(): number {
        return this._id;
    }

    public getMassString(): string {
        return this.BirthWeightValue
            ? this.BirthWeightValue.toString()
            : this.BirthWeight; // do this for backward compatibility
    }

    public convertMass(fromUnit: WeightUnit, toUnit: WeightUnit): void {
        let weight = this.BirthWeightValue || Number(this.BirthWeight);
        if (isNaN(weight))
            return;

        this.BirthWeightValue = WeightUnitConverter.convert(fromUnit, toUnit, weight, 2);
    }

    public hasValue(): boolean {
        return !!this.Date
            || !!this.PlaceOfBirth?.trim()
            || this.GestationWeeksAtBirth?.hasValue()
            || !!this.LabourHours?.trim()
            || !!this.TypeOfBirth?.trim()
            || !!this.Comments?.trim()
            || !!this.Sex?.trim()
            || !!this.BirthWeightValue
            || !!this.BreastfedMonths
            || !!this.ChildCurrentHealth?.trim();
    }

    public setMass(value: number): void {
        this.BirthWeightValue = value;
        if (!!this.BirthWeight?.trim() && !value)
            this.BirthWeight = null;
    }
}

export { ObstetricalHistoryItem };
